import { z } from "zod";
import { userRightSchema } from "../userRightSchema";
import sceneObjectDataSchema from "./sceneObject/sceneObjectDataSchema";

const apiDocumentSchema = z.object({
  documentUuid: z.uuid(),
  name: z.string(),
  version: z.number(),
  userRight: userRightSchema,
  sceneObjects: z.array(z.lazy(() => sceneObjectDataSchema.passthrough())).optional(),
  });

export default apiDocumentSchema;